import type { GroupedValues, ValueWithLabel } from "./types";

export const groupValuesByLabel = (values: ValueWithLabel[]): GroupedValues => {
  return values.reduce((acc, item) => {
    const label = item.label || "";
    if (!acc[label]) {
      acc[label] = [];
    }
    acc[label].push(item.value.toString());
    return acc;
  }, {} as GroupedValues);
};
